import { Button } from '@material-ui/core';
import React from 'react';
import { NavLink } from 'react-router-dom';

import './NotFound.css';

const NotFound = () => {
  return (
    <div id='notfound'>
      <div className='notfound'>
        <h2>404 - Page not found</h2>
        <p>
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailable.
        </p>
        <NavLink to='/'>
          <Button variant='contained' color='primary'>
            Go To Homepage
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default NotFound;
